import {
  MEMBERS_LIST_SORT_OPTIONS,
  type MembersListSortOption,
} from '@/core/components/workspace/people/members-list-sort';
import { ListSortSelect } from '@/core/components/layout';

export type MembersListSortLabels = {
  sort: string;
  options: Record<MembersListSortOption, string>;
};

type MembersListSortSelectProps = {
  value: MembersListSortOption;
  onChange: (next: MembersListSortOption) => void;
  labels: MembersListSortLabels;
};

export function MembersListSortSelect({
  value,
  onChange,
  labels,
}: MembersListSortSelectProps) {
  return (
    <ListSortSelect
      value={value}
      onChange={onChange}
      ariaLabel={labels.sort}
      triggerClassName="w-full sm:w-[12.5rem] sm:shrink-0"
      options={MEMBERS_LIST_SORT_OPTIONS.map((option) => ({
        value: option,
        label: labels.options[option],
      }))}
    />
  );
}
